<template>
  <section class="green-background blue-text pl-5 pr-5 pt-5 pb-2">
    <v-layout column wrap class align-center>
      <v-flex xs12 sm4 class="my-3">
        <div class="text-xs-center">
          <h2 class="headline">The best way to start making your house more resilient!</h2>
          <span class="subheading">Start Now</span>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-container grid-list-xl>
          <v-layout row wrap align-content-space-between="">
            <v-flex xs12 md4>
              <v-card flat class="elevation-0 transparent blue-text" align-center>
                <v-card-text class="text-xs-center pb-0">
                  <v-icon x-large class="blue-text">dashboard</v-icon>
                </v-card-text>
                <v-card-title primary-title class="layout justify-center pt-1 pb-0">
                  <div class="headline text-xs-center">Get your report</div>
                </v-card-title>
                <v-card-text>Is your home as wind-resistant as it could be? Answer these questions to determine your home's wind resistant features and see how your home will weather a storm.</v-card-text>
                <v-layout align-center justify-center row fill-height>
                  <v-btn
                    justify-center
                    class="blue-text yellow-background"
                    dark
                    large
                    round
                    to='survey'
                  >Start answering</v-btn>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 md4>
              <v-card flat class="elevation-0 transparent blue-text">
                <v-card-text class="text-xs-center pb-0">
                  <v-icon x-large class="blue-text">map</v-icon>
                </v-card-text>
                <v-card-title primary-title class="layout justify-center pt-1 pb-0">
                  <div class="headline text-xs-center">View your neighbourhood</div>
                </v-card-title>
                <v-card-text>
                  You can view your neighbourhood and see how many of your neighbours have tried it. Over 20,000 people in Queensland have tried our survey.
                  Make sure you know where you stand!
                </v-card-text>
                <v-layout align-center justify-center row fill-height>
                  <v-btn
                    class="blue-text yellow-background"
                    dark
                    large
                    round
                    @click="$vuetify.goTo('#neighbourhood', {})"
                  >View my neighbours</v-btn>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 md4>
              <v-card flat class="elevation-0 transparent blue-text">
                <v-card-text class="text-xs-center pb-0">
                  <v-icon x-large class="blue-text">account_circle</v-icon>
                </v-card-text>
                <v-card-title primary-title class="layout justify-center pt-1 pb-0">
                  <div class="headline text-xs-center">Create a login</div>
                </v-card-title>
                <v-card-text>
                  Creating a login will help you track your progress, and access a wealth of resources, information and tips
                  on how to make your house more resilient and weather proof.
                </v-card-text>
                <v-layout align-center justify-center row fill-height>
                  <v-btn
                    justify-center
                    class="blue-text yellow-background"
                    dark
                    large
                    round
                    @click="dialogTodo = true"
                  >Create Login</v-btn>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </section>
</template>

<style scoped>
</style>


<script>
export default {
  data() {
    return {
    };
  }
};
</script>
